import { Injectable } from '../../injection';
import { isNil } from '../../utils';
import { ParameterValueType } from '../interfaces/dictionary.interface';

import { IStringTemplateService } from './string-template.interface';

@Injectable()
export class StringTemplateService implements IStringTemplateService {
  private itemFormatRegExp: RegExp = /{{\s?([^{}\s]*)\s?}}/g;

  public compile(template: string, parameters?: Record<string, ParameterValueType>): string {
    if (!parameters) {
      return template;
    }
    return template.replace(this.itemFormatRegExp, (formatItem: string, itemKey: string): string => {
      if (isNil(parameters, itemKey)) {
        return formatItem;
      }
      return `${parameters[itemKey]}`;
    });
  }
}
